import landCfg from "../views/landManagement/landCfg";
import landPage from "../views/landManagement/landPage";

import Main from "../views/main";

const LandRouter = {
  path: "/land-button",
  component: Main,
  title: "落地页管理",
  icon: "el-icon-platform-eleme",
  meta: { keepAlive: true },
  children: [
    {
      path: "/land-page",
      component: landPage,
      name: "landPage",
      title: "域名配置",
      meta: { title: "域名配置", keepAlive: true },
    },
    {
      path: "/land-cfg",
      component: landCfg,
      name: "landCfg",
      title: "落地页配置",
      meta: { title: "落地页配置", keepAlive: true },
    },
  ],
};
export default LandRouter;
